export default "/WebApp/dist/assets/images/balloons.png";